import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'
export default {
    getUsersRanking({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_USERS_RANKING_REQUEST')

        return axios
            .get(`/user-ranking/rankings${paginate}${query}`)
            .then(response => {
                commit('GET_USERS_RANKING_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_USERS_RANKING_FAILURE')
                handleApiError(error, 'Pobranie raportów zbiorczych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getRankingTypes({ commit }) {
        return axios
            .get('/user-ranking/dicts/ranking-types')
            .then(response => {
                commit('GET_RANKING_TYPES', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie rodzajów rankingów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getRankingGroups({ commit }, typeId) {
        return axios
            .get(`/user-ranking/dicts/ranking-groups?rankingType_id=${typeId}`)
            .then(response => {
                commit('GET_RANKING_GROUPS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie grup procesów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateUsersRankingReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/user-ranking/rankings?report=true${query}`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport został wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setUsersRankingFilters({ commit }, filters) {
        commit('SET_USERS_RANKING_FILTERS', filters)
    },
    clearUsersRankingFilters({ commit }) {
        commit('CLEAR_USERS_RANKING_FILTERS')
    },
}